import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { formatText } from 'core/i18n';
import React, { useEffect } from 'react';
import { recordEventStepSuccess } from 'utilities/uTagging';

export const SuccessSigningView = ({ investmentType, onHandleChangeStep }) => {
    useEffect(() => {
        recordEventStepSuccess(investmentType, '/onboarding/contrato/', 'contrato firmado correctamente', {
            event_name: 'event_success',
            action: 'success',
            format: 'steps',
            component: 'funnel',
            element: 'contract',
        });
    }, []);

    return (
        <MessagesScreen
            iconClass="icons icons--icon-checked"
            title={formatText('messagesScreen-signedSuccessfullyTitle')}
            buttonText={formatText('button-continue')}
            showRoadmapNavigation={true}
            roadmapNavigationProps={{
                buttonPrevHidden: true,
                buttonContinueAction: onHandleChangeStep,
            }}
        >
            {formatText('messagesScreen-signedInfo')}
        </MessagesScreen>
    );
};
